import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { IField, IValueChangedEventArgs } from '@azavista/components/shared';
import { IStopProcessDialogComponentResult } from './declarations';

@Component({
    templateUrl: 'stop-process-dialog.component.html',
})
export class StopProcessDialogComponent implements OnInit {
    field: IField;
    fieldValue = false;
    fields: IFields;

    constructor(
        private readonly dialogRef: MatDialogRef<StopProcessDialogComponent, IStopProcessDialogComponentResult>
    ) { }

    ngOnInit(): void {
        this.fields = this.createFields();
    }

    onPublishSavedMessagesFieldValueChanged(args: IValueChangedEventArgs): void {
        this.fields.publishSavedMessagesValue = !!args.value;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onOk(): void {
        const result: IStopProcessDialogComponentResult = { publishSavedMessages: this.fields.publishSavedMessagesValue };
        this.dialogRef.close(result);
    }

    private createFields(): IFields {
        const fields: IFields = {
            publishSavedMessages: {
                id: 'publishSavedMessages', editable: true,
                schema: { type: 'boolean' }
            } as IField,
            publishSavedMessagesValue: false
        };
        return fields;
    }
}

interface IFields {
    publishSavedMessages: IField;
    publishSavedMessagesValue: boolean;
}
